import QueueView from '../components/screens/QueueView';

function QueuePage({ auth, queue }) {
  return (
    <QueueView
      currentUser={auth.currentUser}
      queueForm={queue.queueForm}
      selectedFile={queue.selectedFile}
      isSubmittingQueue={queue.isSubmittingQueue}
      queueStatus={queue.queueStatus}
      lastQueue={queue.lastQueue}
      lastProcessingJob={queue.lastProcessingJob}
      onSubmit={(event) => queue.handleQueueSubmit(event, auth.currentUser)}
      onMessageChange={queue.handleMessageChange}
      onScreenChange={queue.handleScreenChange}
      onFileChange={queue.handleFileChange}
    />
  );
}

export default QueuePage;
